import * as selectors from './email.selectors';
import reducer from './email.reducers';

export default reducer;
export { selectors, reducer };
export { EmailAction } from './email.actions';
export { EmailEffects } from './email.effects';
export { EmailState, Email } from './email.model';
export { EmailService } from './email.service';
